import { SignIn } from "@clerk/react";
import { ila26ClerkAppearance } from "@/config/clerkAppearance";
import { LogoIla26 } from "@/styles/style";
import { getLogo } from "@/utils/env/logo";
import { Box } from "@mui/material";

// Ila26 sign-in surface for the Clerk activation (Phase 6).
//
// Rendered by App.tsx directly under <Show when="signed-out"> — no
// route needed. routing="hash" tells Clerk to track sub-steps
// (factor-one, verify, etc.) via URL hash fragments, which means the
// browser pathname is preserved so post-sign-in the app mounts on
// whatever deep link the user originally hit. Also lets us skip
// hoisting BrowserRouter above the Clerk gate.
//
// signUpUrl is intentionally omitted — end users are provisioned by
// the ClerkMigration tool, not by self-signup.
const SignInPage = () => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 4,
            padding: "48px 16px",
        }}
    >
        <LogoIla26 src={getLogo()} style={{ height: 40 }} />
        <SignIn routing="hash" appearance={ila26ClerkAppearance} />
    </Box>
);

export default SignInPage;
